import { Topic } from '.';
import { CellContext } from '@tanstack/react-table';
import { LearnerProgress } from '.';
import styled from 'styled-components';
import { TopicIcon, TopicPill, TopicText } from '../TopicPill';
import { TOPIC_TO_COLOR } from '../../../theme';
import { SmallPortalTooltip } from '../../Tooltip';
import {
  TooltipContent,
  TooltipDetail,
  TooltipDetailHighlight,
  TooltipTitle,
} from './Tooltip';
import React from 'react';
import { LEARNING_PLAN_UNIT_TYPE } from '../../LearningPlan/LearningPlanUnit';

const TopicsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export default function TopicsCell(
  info: CellContext<LearnerProgress, Topic[]>
) {
  const topics = info.getValue();
  const rowId = info.row.id;
  return (
    <TopicsContainer>
      {topics.map((topic: Topic, index: number) => {
        const topicColor =
          TOPIC_TO_COLOR[topic.name as keyof typeof TOPIC_TO_COLOR];
        const iconUrl = topic.iconUrl;
        const pillTooltipId = `topic-details-${rowId}-${topic.name.replace(
          /\s+/g,
          '_'
        )}-${index}`;

        return (
          <React.Fragment key={`${topic.name}-${index}`}>
            <TopicPill
              backgroundColor={topicColor}
              data-tooltip-id={pillTooltipId}
            >
              {iconUrl && <TopicIcon src={iconUrl} />}
              <TopicText>{topic.name}</TopicText>
            </TopicPill>
            {topic.details && topic.details.length > 0 && (
              <SmallPortalTooltip
                anchorSelect={`[data-tooltip-id="${pillTooltipId}"]`}
              >
                <TooltipContent>
                  <TooltipTitle>{topic.name}</TooltipTitle>
                  {topic.details.map((detail, detailIdx) => (
                    <TooltipDetail key={detailIdx}>
                      {detailIdx + 1}.{' '}
                      <TooltipDetailHighlight>
                        {detail.name}
                      </TooltipDetailHighlight>{' '}
                      -
                      {detail.completed !== undefined &&
                      detail.total !== undefined ? (
                        ` ${detail.completed}/${detail.total} exercises`
                      ) : (
                        <>
                          {detail.coreCompleted !== undefined &&
                            detail.coreTotal !== undefined &&
                            ` ${detail.coreCompleted}/${
                              detail.coreTotal
                            } CORE ${
                              detail.type ===
                              LEARNING_PLAN_UNIT_TYPE.CONTENT_MODULE
                                ? 'activities'
                                : 'exercises'
                            }`}
                          {detail.stretchCompleted !== undefined &&
                            detail.stretchTotal !== undefined &&
                            detail.stretchTotal > 0 &&
                            detail.coreCompleted !== undefined &&
                            ` + `}
                          {detail.stretchCompleted !== undefined &&
                            detail.stretchTotal !== undefined &&
                            detail.stretchTotal > 0 &&
                            `${detail.stretchCompleted}/${
                              detail.stretchTotal
                            } STRETCH ${
                              detail.type ===
                              LEARNING_PLAN_UNIT_TYPE.CONTENT_MODULE
                                ? 'lessons'
                                : 'exercises'
                            }`}
                        </>
                      )}
                    </TooltipDetail>
                  ))}
                </TooltipContent>
              </SmallPortalTooltip>
            )}
          </React.Fragment>
        );
      })}
    </TopicsContainer>
  );
}
